import { FieldType } from './types';
import ColorField from './fields/ColorField';
import ToggleField from './fields/ToggleField';
import SchemaTextField from './fields/SchemaTextField';
import NumberField from './fields/NumberField';
import UrlField from './fields/UrlField';
import SelectField from './fields/SelectField';
import JsonField from './fields/JsonField';
import ArrayField from './fields/ArrayField';
import IconMapField from './fields/IconMapField';
import MenuListField from './fields/MenuListField';
import MenuIconMapField from './fields/MenuIconMapField';
import SubsystemVersionField from './fields/SubsystemVersionField';

export const fieldRegistry: Record<FieldType, React.ComponentType<any>> = {
  color: ColorField,
  toggle: ToggleField,
  text: SchemaTextField,
  textarea: SchemaTextField,
  number: NumberField,
  url: UrlField,
  select: SelectField,
  json: JsonField,
  array: ArrayField,
  date: SchemaTextField,
  'icon-map': IconMapField,
  'menu-list': MenuListField,
  'menu-icon-map': MenuIconMapField,
  'subsystem-version': SubsystemVersionField,
};
